import { TranslateDirective, TranslationService } from '@foundation/translations/services';

import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { ADMIN_NAVIGATION_ENTRIES, extractAdditionalAdminNavigationEntries } from '../admin-navigation';

interface AdminShellNavigationItem {
	label: () => string;
	path: string;
}

@Component({
	selector: 'lib-admin-shell',
	standalone: true,
	imports: [RouterModule, TranslateDirective],
	templateUrl: './admin-shell.component.html',
	styleUrl: './admin-shell.component.css',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminShellComponent {
	private _activatedRoute = inject(ActivatedRoute);
	private _translationService = inject(TranslationService);

	navigationItems: AdminShellNavigationItem[] = [
		...ADMIN_NAVIGATION_ENTRIES,
		...extractAdditionalAdminNavigationEntries(this._activatedRoute.routeConfig),
	].map((navigationEntry) => ({
		label: this._translationService.prep(navigationEntry.label),
		path: navigationEntry.path,
	}));
}
